import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from './Pages/Home';
import Callback from './Pages/Callback';
import Dev from './Pages/Dev';
import Login from './Pages/Login';
import Register from './Pages/Register';
import VenueRegister from './Pages/VenueRegister';
import RecognizeSong from './Components/RecognizeSong';
import Forbidden from './Pages/403/403';
import { RequireRole } from './Services/RequireRole';
import Administrazione from './Pages/Administrazione/Administrazione';
import Profile from './Pages/Profile';
import VenuePage from './Pages/VenuePage';
import FeedPage from './Pages/FeedPage';
import OnboardingArtists from './Pages/OnboardingArtists';
import Settings from './Pages/Settings';
import ForgotPassword from './Pages/ForgotPassword';
import ResetPassword from './Pages/ResetPassword';
import VerifyEmail from './Pages/VerifyEmail';
import InviteAccept from './Pages/InviteAccept';
import Terms from './Pages/Legal/Terms';
import Privacy from './Pages/Legal/Privacy';
import Contact from './Pages/Legal/Contact';
import { NotificationsProvider } from './Services/NotificationsContext';
import { GoingOutProvider } from './Services/GoingOutContext';
import NotificationToasts from './Components/Notifications/NotificationToasts';

function App() {
  return (
    <div className="App">
     <Router>
        <NotificationsProvider>
          {/* Kvällsfrågan visas på kartan, i menyn bakom avataren, på den
              egna profilen och i flödet. Ett tillstånd för alla fyra —
              annars kan två av dem säga olika saker samtidigt. */}
          <GoingOutProvider>
            <NotificationToasts />

            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/callback" element={<Callback />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/feed" element={<FeedPage />} />
              <Route path="/onboarding/artists" element={<OnboardingArtists />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/profile/:userId" element={<Profile />} />
              <Route path="/venue/:venueId" element={<VenuePage />} />
              <Route path="/settings" element={<Settings />} />

              {/* Lösenordsflödet. Alla tre nås utloggad — det är hela poängen. */}
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/verify-email" element={<VerifyEmail mode="verify" />} />
              <Route
                path="/confirm-email-change"
                element={<VerifyEmail mode="email-change" />}
              />

              {/* Vänbjudan. Publik med flit: mottagaren ska se vem som
                  bjuder in innan hen bestämmer sig för att skapa ett konto.
                  Backend skickar bara ett namn till den som är utloggad. */}
              <Route path="/invite/:token" element={<InviteAccept />} />

              {/* Publika och länkade från sidfoten. */}
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/contact" element={<Contact />} />

              <Route element={<RequireRole minRole="CONTRIBUTOR" />}>
                <Route path="/recognize" element={<RecognizeSong />} />
              </Route>

              <Route element={<RequireRole minRole="ADMIN" />}>
                <Route path="/administrazione" element={<Administrazione />} />
              </Route>

              <Route path="/dev" element={<Dev />} />
              <Route path="/403" element={<Forbidden />} />
            </Routes>
          </GoingOutProvider>
        </NotificationsProvider>
      </Router>
    </div>
  );
}

export default App;
